// ---------------------------------------------------------------------------
// Encerramento de sessão local — ponto ÚNICO de limpeza.
//
// Nasceu do handoff 0097: trocar senha (própria ou por admin) e o reset por
// e-mail (0098) revogam TODAS as sessões no backend. São três gatilhos que
// precisam do mesmo desfecho no front, e antes disso a limpeza estava
// duplicada e divergente dentro do saga.
//
// ⚠️ A chave do redux-persist é `MYSHOP-APP` (ver `store/modules/reduxPersist.js`),
// logo o item do localStorage é `persist:MYSHOP-APP`. O saga removia
// `persist:root` — nome default do redux-persist, que este app nunca usou. Era
// no-op: a limpeza real só acontecia porque o reducer volta ao `initialState` e
// o redux-persist reescreve o storage por conta própria, o que é uma corrida
// contra o redirect (e o `logoutRequest` redireciona sem espera nenhuma).
// Removendo a chave certa, o encerramento deixa de depender desse timing.
// ---------------------------------------------------------------------------

import axios from '../../../services/axios';
import * as actions from './actions';

export const PERSIST_STORAGE_KEY = 'persist:MYSHOP-APP';

// Chaves soltas que o app grava fora do redux-persist.
const EXTRA_STORAGE_KEYS = [
   'token',
   'app:activeModule',
   // Removida por último por segurança: era a chave que o saga tentava limpar.
   // Se sobrou algo de uma versão antiga do app, some aqui.
   'persist:root',
];

/**
 * Limpa o rastro local da sessão: storage + header de Authorization.
 * Não mexe no redux e não navega — ver `endSession`.
 */
export function clearLocalSession() {
   localStorage.removeItem(PERSIST_STORAGE_KEY);
   EXTRA_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
   delete axios.defaults.headers.Authorization;
}

/**
 * Encerra a sessão de ponta a ponta: zera o redux, limpa o local e leva ao
 * login. É o desfecho obrigatório de qualquer operação que revogue sessão no
 * backend (`sessions_revoked: true`).
 *
 * A ordem importa: o dispatch primeiro (o reducer volta ao `initialState`, e é
 * esse estado que o redux-persist eventualmente grava), a limpeza depois.
 *
 * @param {Function} dispatch      `store.dispatch` ou o `useDispatch()` da tela
 * @param {object}  [options]
 * @param {string|null} [options.redirectTo='/login']  `null` encerra a sessão
 *        SEM navegar — para quem precisa navegar por conta própria com o
 *        react-router (ex.: levar o e-mail para o login via `location.state`,
 *        que um `window.location` descartaria).
 * @param {number}  [options.delayMs=0]  respiro para o toast ser lido antes do
 *                                       reload duro (o interceptor usa 1000)
 */
export function endSession(dispatch, options = {}) {
   const { redirectTo = '/login', delayMs = 0 } = options;

   dispatch(actions.logoutSuccess());
   clearLocalSession();

   if (!redirectTo) return;

   // `window.location` (e não `navigate`) de propósito: o reload duro descarta
   // qualquer estado de tela que tenha sobrado da sessão morta.
   const go = () => {
      if (window.location.pathname !== redirectTo) {
         window.location.href = redirectTo;
      }
   };

   if (delayMs > 0) setTimeout(go, delayMs);
   else go();
}

export default endSession;
